// extracted by mini-css-extract-plugin
module.exports = {"main":"Logo_main__1GySa","img":"Logo_img__G8dkJ"};